"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    marginBottom: {
      marginBottom: 20
    },
    formLabel: {
      fontSize: 12,
      marginTop: 3
    },
    colorPicker: {
      width: "100%",
      marginTop: ".2rem",
      marginBottom: "1rem"
    }
  };
});

var AttributesSelect = function AttributesSelect(_ref) {
  var objectsForm = _ref.objectsForm,
      properties = _ref.properties,
      handleItemAttribute = _ref.handleItemAttribute,
      handlePropertyChange = _ref.handlePropertyChange,
      accordionFilter = _ref.accordionFilter;
  var classes = useStyles();
  var attributes = properties.attributes;

  var handleSelectAccordion = function handleSelectAccordion(e) {
    return handlePropertyChange(properties, "childAccordion", e.target.value);
  };

  return /*#__PURE__*/React.createElement("form", {
    style: {
      marginBottom: "1rem"
    }
  }, accordionFilter(objectsForm).length > 0 && /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Define a que acordeon pertenece",
    "aria-label": "value",
    placement: "top"
  }, /*#__PURE__*/React.createElement(_core.FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(_core.FormLabel, {
    component: "label",
    className: classes.formLabel
  }, "Definir a que acordeon pertenece"), /*#__PURE__*/React.createElement(_core.RadioGroup, {
    "aria-label": "childAccordion",
    name: "childAccordion",
    value: properties.childAccordion,
    onChange: handleSelectAccordion
  }, accordionFilter(objectsForm).filter(function (res) {
    return res.i !== "step-0";
  }).map(function (acc, key) {
    return /*#__PURE__*/React.createElement(_core.FormControlLabel, {
      key: key,
      value: acc.i,
      control: /*#__PURE__*/React.createElement(_core.Radio, {
        color: "primary"
      }),
      label: acc.label
    });
  })), /*#__PURE__*/React.createElement(_core.Button, {
    disabled: !properties.childAccordion,
    size: "small",
    onClick: function onClick(e) {
      e.preventDefault();
      handlePropertyChange(properties, "childAccordion", null);
    }
  }, "Reset accordion")))), /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Etiqueta".concat(!properties.validations.allowNull ? " *" : ""),
    value: attributes.label,
    onChange: function onChange(e) {
      handleItemAttribute(properties, "label", e.target.value);
    },
    className: classes.marginBottom
  }), /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Placeholder",
    value: attributes.placeholder,
    onChange: function onChange(e) {
      handleItemAttribute(properties, "placeholder", e.target.value);
    },
    className: classes.marginBottom
  }));
};

var _default = AttributesSelect;
exports.default = _default;